module.exports = __webpack_public_path__ + "static/img/map.8029a25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/service/map.png
// module id = ndjF
// module chunks = 1